import React from 'react'
import style from './Content.module.css'

const Content = () => {
    return (
        
        <div className={style.wrapping}>
            <div className={style.content}>
                <h2>Challenge</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit laboriosam earum cum, vel impedit consequuntur libero velit consectetur fuga repellat ullam, necessitatibus ipsam illo non expedita molestias quos numquam mollitia. Excepturi, quo dolorum ab eum sequi ipsa voluptatum dignissimos quam facilis deleniti molestias? Dicta, non!</p>
            </div>
            <div className={style.content}>
                <h2> Approach</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit laboriosam earum cum, vel impedit consequuntur libero velit consectetur fuga repellat ullam, necessitatibus ipsam illo non expedita molestias quos numquam mollitia. Excepturi, quo dolorum ab eum sequi ipsa voluptatum dignissimos quam facilis deleniti molestias? Dicta, non!

                </p>
            </div>
            <ul>
                <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit laboriosam earum cum, vel impedit consequuntur libero velit consectetur fuga repellat ullam</li>
                <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit laboriosam earum cum, vel impedit consequuntur libero velit consectetur fuga repellat ullam</li>
                <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit laboriosam earum cum, vel impedit consequuntur libero velit consectetur fuga repellat ullam</li>
            </ul>
        </div>

       
      
        
    )
}

export default Content 
